import { Routes } from '@angular/router';
import { TabsComponent } from './tabs/tabs.component';

export const routes: Routes = [
  {
    path: '',
    component: TabsComponent,
    children: [
      {
        path: '',
        redirectTo: 'counter',
        pathMatch: 'full'
      },
      {
        path: 'counter',
        loadComponent: () => import('./counter/counter.component').then(m => m.CounterComponent)
      },
      {
        path: 'stats',
        loadComponent: () => import('./stats/stats.component').then(m => m.StatsComponent)
      },
      {
        path: 'connect',
        loadComponent: () => import('./connect/connect.component').then(m => m.ConnectComponent)
      },
      {
        path: 'help',
        loadComponent: () => import('./help/help.component').then(m => m.HelpComponent)
      }
    ]
  }
];